// Copyright © 2019-2026 Focal Systems. All rights reserved.

import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import deBackOffice from "@/lib/i18n/de/back-office.json";
import deForm from "@/lib/i18n/de/form.json";
import deGeneral from "@/lib/i18n/de/general.json";
import deLogin from "@/lib/i18n/de/login.json";
import deUi from "@/lib/i18n/de/ui.json";
import enBackOffice from "@/lib/i18n/en/back-office.json";
import enForm from "@/lib/i18n/en/form.json";
import enGeneral from "@/lib/i18n/en/general.json";
import enLogin from "@/lib/i18n/en/login.json";
import enUi from "@/lib/i18n/en/ui.json";

import frBackOffice from "@/lib/i18n/fr/back-office.json";
import frForm from "@/lib/i18n/fr/form.json";
import frGeneral from "@/lib/i18n/fr/general.json";
import frLogin from "@/lib/i18n/fr/login.json";
import frUi from "@/lib/i18n/fr/ui.json";

import plBackOffice from "@/lib/i18n/pl/back-office.json";
import plForm from "@/lib/i18n/pl/form.json";
import plGeneral from "@/lib/i18n/pl/general.json";
import plLogin from "@/lib/i18n/pl/login.json";
import plUi from "@/lib/i18n/pl/ui.json";

const resources = {
  en: {
    "back-office": enBackOffice,
    form: enForm,
    general: enGeneral,
    ui: enUi,
    login: enLogin,
  },
  de: {
    "back-office": deBackOffice,
    form: deForm,
    general: deGeneral,
    ui: deUi,
    login: deLogin,
  },
  fr: {
    "back-office": frBackOffice,
    form: frForm,
    general: frGeneral,
    ui: frUi,
    login: frLogin,
  },
  pl: {
    "back-office": plBackOffice,
    form: plForm,
    general: plGeneral,
    ui: plUi,
    login: plLogin,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    // Restrict to the languages we ship and normalise region-tagged detections
    // (e.g. "en-GB" → "en") so i18n.language always matches a supported code.
    supportedLngs: ["en", "de", "fr", "pl"],
    load: "languageOnly",
    // Only honour an explicit saved choice; with no localStorage value we fall
    // back to "en" rather than guessing from the browser's navigator language.
    detection: {
      order: ["localStorage"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
    defaultNS: "back-office",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
